import './Footer.css';
import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p>©Benoit,Brandon,Priscilia,Ornella.</p>
    </footer>
  );
}
